import * as angular from 'angular';
import 'angular-route';
import 'angular-animate';
import 'angular-sanitize';
import 'angular-local-storage';
import 'angular-loading-bar';
import 'angular-ui';
import 'angular-bootstrap-toggle';
import 'oclazyload';
import { gpCommon } from '../app-common/app';
import { gpDataApp } from '../app-data/app';

export const gpHome = angular.module("gamePlanHomeApp",
    [
        'ngRoute',
        'ngAnimate',
        // $sanitize, for the plain-string ng-bind-html bindings in analysis-report and analyze-detail.
        'ngSanitize',
        'angular-loading-bar',
        'ui.bootstrap',
        gpCommon.name,
        gpDataApp.name,
        'oc.lazyLoad',
    ]);
